import Chart from 'react-google-charts'
import { Card, CardBody, Col } from 'reactstrap'
import { ComboCharts } from '../../../../Utils/Constants'
import { comboChartData, comboChartDataOption } from '../../../../Data/Charts/GoogleChart/GoogleChartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const ComboChart = () => {
  return (
    <Col sm="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={ComboCharts} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="combo-chart">
            <Chart chartType="ComboChart" width="100%" height="500px" data={comboChartData} options={comboChartDataOption} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default ComboChart